<template>
  <div class="container padding_large">
    <PageHeader />
    <div class="center-protected">
      <h2>PAGE IS PASSWORD PROTECTED</h2>
      <form class="password-form" @submit.prevent="unlockPage">
        <input type="password" placeholder="password" v-model="pass" required />
        <button class="btn btn-primary" role="submit" type="submit">
          UNLOCK
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "pass-protection",
  data() {
    return {
      pass: null
    };
  },
  computed: {
    ...mapGetters(["currentPostType"])
  },
  methods: {
    ...mapActions(["loadPage"]),
    unlockPage() {
      const payload = {
        id: this.currentPageID,
        postType: this.currentPostType,
        attrs: { password: this.pass }
      };
      this.loadPage(payload);
    }
  }
};
</script>

<style lang="scss">
.center-protected {
  text-align: center;
  input {
    border: 2px solid #323232;
    padding: 8px 10px;
  }
}
</style>
